import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import '../shared.css';

const PGCategoryCreate = () => {
  const history = useHistory();
  const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
  const [name, setName]                   = useState('');
  const [isLoading, setIsLoading]         = useState(false);
  const [errorMessage, setErrorMessage]   = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, branchId, token, logout]);

  const submitData = async (e) => {
    e.preventDefault();
    if (!name) { setErrorMessage('PG Category name is required.'); return; }
    setIsLoading(true);
    try {
      await postData('PGCategoryApi', { Name: name, CreatedBy: userId, CompanyId: companyId, CreatedDate: new Date() }, token);
      setSuccessMessage('PG Category created successfully!');
      setErrorMessage('');
      history.push('/PGCategoryIndex');
    } catch (err) {
      console.error(err);
      setErrorMessage('Failed to create PG Category.');
    } finally { setIsLoading(false); }
  };

  return (
    <Fragment>
      <div className="pg-container">
        <form onSubmit={submitData}>
          <div className="pg-header">
            <h5 className="pg-title">PG Category — Create</h5>
            <div className="pg-header-actions">
              <button type="submit" className="pg-btn pg-btn-success" disabled={isLoading}>
                <DoneIcon /> {isLoading ? 'Saving…' : 'Save'}
              </button>
              <Link to="/PGCategoryIndex" className="pg-btn pg-btn-neutral"><ReplyAllIcon /> Back to List</Link>
            </div>
          </div>
          {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
          {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}
          <div className="pg-card">
            <div className="pg-form-grid" style={{ gridTemplateColumns: '1fr' }}>
              <div className="pg-field">
                <label className="pg-label">PG Category Name <span className="req">*</span></label>
                <input className="pg-input" type="text" placeholder="Enter PG category name"
                  value={name} onChange={e => setName(e.target.value)} required maxLength={100} />
              </div>
            </div>
          </div>
        </form>
        <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
      </div>
    </Fragment>
  );
};

export default PGCategoryCreate;
